let ol = require('openlayers');
let jsts = require('jsts/dist/jsts');
let parser = new jsts.io.OL3Parser(undefined, ol);

let AbstractOperation = require('../operations/abstract');
let SymmetricDifferenceResult = require('../operations/types/symDifferenceResult');

/**
 * Класс SymmetricDifference
 * @extends AbstractOperation
 */
class SymmetricDifference extends AbstractOperation {

    /**
     * Создает экземпляр класса SymmetricDifference
     */
    constructor() {
        super()
    }

    /**
     *
     * @param params
     * @return {SymmetricDifferenceResult}
     */
  execute(params) {
    let difference = operation(params.featureA, params.featureB);
    return new SymmetricDifferenceResult({
      feature: difference,
      geometry: difference.getGeometry()
    })
  }
}

function operation(featureA, featureB) {
  let geomA = parser.read(featureA.getGeometry());
  let geomB = parser.read(featureB.getGeometry());
  let result = geomA.symDifference(geomB);
  return new ol.Feature({
    geometry: parser.write(result)
  });
}

module.exports = SymmetricDifference;